module.exports = __webpack_public_path__ + "img/0xd2a4cff31913016155e38e474a2c06d08be276cf.75f52164.png";